import { useState, useEffect } from 'react';
import '../utilities/base-url.utils.js';
import { setToString } from '../utilities/set.utils.js';
import '../constants/domains.js';
import '../constants/globals.js';
import '../constants/tokens-color.js';
import '../types/enums.js';
import { iterToSet } from '../utilities/transform.utils.js';
import '../utilities/manifest-icons.utils.js';
import '../utilities/manifest-js.utils.js';
function getBrowserClasses() {
  let possibleNames = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Set();
  const {
    userAgent
  } = navigator;
  if (userAgent.indexOf('Safari/') !== -1 && userAgent.indexOf('Chrome/') === -1 && userAgent.indexOf('Chromium/') === -1) {
    possibleNames.add('swan-safari');
  }
  if (userAgent.indexOf('Firefox/') !== -1 && userAgent.indexOf('Seamonkey/') === -1) {
    possibleNames.add('swan-firefox');
  }
  if (userAgent.indexOf('Trident/') !== -1) {
    possibleNames.add('swan-ie11') // this gets put on any version of IE
    ;
  }

  if (userAgent.indexOf('Edge/') !== -1) {
    // old (pre-Chromium) Edge
    possibleNames.add('swan-edge');
    possibleNames.add('swan-edgeold') // this gets put on ANY version of Edge
    ;
  }

  if (userAgent.indexOf('Edg/') !== -1) {
    // Chromium-based Edge
    possibleNames.add('swan-edge') // this gets put on ANY version of Edge
    ;
  }

  return possibleNames;
}
function useBrowserClasses(autoSyncWithHead, initialClassNames) {
  const [browserClassName, setBrowserClassName] = useState(() => setToString(iterToSet(initialClassNames)));
  useEffect(() => {
    setBrowserClassName(setToString(getBrowserClasses(iterToSet(initialClassNames))));
  }, [initialClassNames]);
  useEffect(() => {
    if (autoSyncWithHead && browserClassName) {
      try {
        const head = document.querySelector('head');
        head === null || head === void 0 ? void 0 : head.classList.add(browserClassName);
        return () => {
          return head === null || head === void 0 ? void 0 : head.classList.remove(browserClassName);
        };
      } catch (e) {
        console.info('Could not sync browser class name.');
      }
    }
  }, [browserClassName, autoSyncWithHead]);
  return browserClassName;
}
export { useBrowserClasses };